/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type ItemDisplayPromoCodeWrapper_item$ref = any;
export type CartItemPromoCode_item$ref = any;
export type CartItemPromoCode_item = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": ItemDisplayPromoCodeWrapper_item$ref;
    readonly " $refType": CartItemPromoCode_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartItemPromoCode_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "ItemDisplayPromoCodeWrapper_item",
            "args": null
        }
    ]
} as any);
(node as any).hash = '5330d7e632ed23ed8ee69cc9b177dc7a';
export default node;
